import React from 'react';
import { connect } from 'react-redux';

import { authenticateUser } from '../../store/auth';
import LoginWrapper from './components/Login';

const mapStateToProps = (state) => {
  return  {
    authenticatedID: (typeof state.auth.sub !== 'undefined')  ? state.auth.sub : null,
    authedUser: state.auth,
    userRoles: state.auth.User ? state.auth.User.roles : [] ,
    redirectAction: state.location ? state.location.pathname : ''
};};

const mapDispatchToProps = {
  authenticateUser,
};

export default function (Component) {
  class LoginHOC extends React.Component {
    render () {
      let isAdvisor = true;
      const { authenticatedID, userRoles, redirectAction } = this.props;

      if (userRoles && userRoles.length > 0) isAdvisor = false;
      userRoles.forEach(role => {
        if (role && role.id === 3) isAdvisor = true;
      });

      if (authenticatedID === null || (!isAdvisor && redirectAction.indexOf('advisor') > -1)) {
        return <LoginWrapper {...this.props} />;
      }

      return <Component {...this.props} />;
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(LoginHOC);
}



// WEBPACK FOOTER //
// ./src/components/LoginHOC/index.js